<section *ngIf="!singleErrorView" class="section-separator no-margin padding-top-20"></section>
<section class="row padding-10">
	<p *ngIf="!singleErrorView" class="text-16">
		<icon class="color-red" type="exclamation-circle"></icon>
		<span class="icon-caption text-bold padding-left-10" dcrHTMLKey="SLEEVE_REPLACE_TITLE">The following sleeves cannot be analyzed.</span>
	</p>
	<section class="grid sleeve-list">
		<section class="header row padding-bottom-10">
			<section class="col-12">
				<p class="text-14-bold" dcrHTMLKey="SLEEVE_NAME_LABEL">Sleeve Name</p>
			</section>
			<section class="col-12">
				<p class="text-14-bold" dcrHTMLKey="SLEEVE_ISSUE_LABEL">Issue</p>
			</section>
		</section>
		<section *ngFor="let sleeve of sleeveData" class="row padding-bottom-10">
			<section class="col-12">
				<p class="text-14 padding-right-5">{{ sleeve.name }}</p>
			</section>
			<section class="col-12">
				<p class="text-14" dcrHTMLKey="{{ sleeve.issue }}_ISSUE">{{ sleeve.issue }}</p>
			</section>
		</section>
	</section>
</section>
